<app-performance>
    <app-data-grid-comp
        [gridId]="gridId"
        [tableId]="db_tables.GoalPlans"
        [columns]="columns"
        [filterCategories]="filterCategories"
        [gridDataResult]="gridDataResult"
        [isLoading]="isLoading"
        [pageSize]="pageSize"
        [skip]="skip"
        category="GoalPlans"
        [rowSelectionSettings]="{
            canSelectRows: true,
            selectableMode: 'multiple',
            selectRowBy: 'id'
        }"
        clickableRows="true"
        [isLoading]="isLoading"
        [clearSelectedItems]="clearSelectedItems"
        searchable="true"
        [sortable]="{
            mode: 'multiple'
        }"
        [sortableColumns]="sortableColumns"
        [rowActionButtons]="gridActionButtons"
        (rowActionEvent)="rowActionEvent($event)"
        (emitGridStateChangeEvent)="gridStateChange($event)"
        (emitOpenDialogEvent)="editOrCreatePlan($event)"
        (emitDeleteEvent)="deleteGoalPlans($event)"
    ></app-data-grid-comp>
</app-performance>
